/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconNavigationWest = createReactComponent("navigation-west", "IconNavigationWest", [
  ["path", { d: "M9 3l1 6l2 -3.75l2 3.75l1 -6", key: "svg-0" }],
  ["path", { d: "M16 21l-4 -8l-4 8l4 -2z", key: "svg-1" }]
]);

export { IconNavigationWest as default };
//# sourceMappingURL=IconNavigationWest.js.map
